import Isotope from "isotope-layout";
import Swiper from "swiper";

export const getCookie = (name) => {
    var cookieArr = document.cookie.split(";");
    for (var i = 0; i < cookieArr.length; i++) {
        var cookiePair = cookieArr[i].split("=");

        /* Removing whitespace at the beginning of the cookie name
        and compare it with the given string */
        if (name === cookiePair[0].trim()) {
            return decodeURIComponent(cookiePair[1]);
        }
    }

    return null;
}

export const getParents = (elem) => {
    var parents = [];
    while (elem.parentNode && elem.parentNode.nodeName.toLowerCase() !== 'body') {
        elem = elem.parentNode;
        parents.push(elem);
    }
    return parents;
}

export const addZeroBeforeNumber = (number) => {
    return (number > 9) ? number : `0${number}`
}

export const initializeSwiper = (item, params) => {
    const swiper_el = new Swiper(item, params);
    swiper_el.init();
    return swiper_el;
}

export const initializeIsotop = (item) => {
    let filter_menu = item.closest(".grid-wrapper").querySelector(".filter-menu");

    const grid = new Isotope(item, {
        itemSelector: '.grid-item',
        layoutMode: 'masonry',
        percentPosition: true,
        stagger: 0,
        masonry: {
            columnWidth: '.grid-sizer',
        }
    })

    setTimeout(() => {
        grid.arrange({ filter: `*` })
    }, 1000);

    filter_menu && filter_menu.querySelectorAll("li").forEach((el) => {
        el.querySelector("span").addEventListener("click", function (e) {
            let element = e.target,
                filtered_text = element.getAttribute("data-filter");

            filter_menu.querySelectorAll("li").forEach((elm) => elm.classList.remove("active"))
            element.closest("li").classList.add("active");
            grid.arrange({ filter: filtered_text === "*" ? "*" : `.${filtered_text}` })
        })
    })

    return grid
}

export const InputField = (value) => {

    document.querySelectorAll(".quantity").forEach(item => {
        let num = value ? value : 0,
            el = item.querySelector(".qty-text"),
            plusBtn = item.querySelector(".qty-plus"),
            minusBtn = item.querySelector(".qty-minus");

        plusBtn.addEventListener("click", () => {
            num = num + 1;
            el.setAttribute("value", num);
        });

        minusBtn.addEventListener("click", () => {
            num = num > 0 ? num - 1 : 0;
            el.setAttribute("value", num)
        });

        el.setAttribute("value", num);
    })
}

// export const sendEmail = async (data) => {
//     const req = await fetch(`${process.env.REACT_APP_API_URL}/send`, {
//         method: 'post',
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify(data)
//     }).then(res => res.json()).then(data => data)
//     return await req
// }

export const sendEmail = async (data) => {
    const apiUrl = 'https://sitecontact.hasotech.com/sendmail.php';

    const formData = new FormData();
    formData.append('name', data.name);
    formData.append('email', data.email);
    formData.append('phone', data.phone);
    formData.append('comment', data.comment);
    formData.append('terms_condition', data.terms_condition); // Corrected field key

    // Optional file upload if needed
    if (data.file) {
        formData.append('file', data.file); // This must be a File or Blob
    }

    try {
        const response = await fetch(apiUrl, {
            method: 'POST',
            body: formData
        });

        const result = await response.json(); // Use .text() if response isn't JSON
        return result;
    } catch (error) {
        console.error('Error sending email:', error);
        return { success: false, error };
    }
};


export const sendEmail1 = async (data) => {
    const apiUrl = 'https://sitecontact.hasotech.com/sendmail.php';

    const formData = new FormData();
    // formData.append('name', data.name);
    formData.append('email', data.email);
    // formData.append('phone', data.phone);
    formData.append('comment', "Connect Now Or Schedule Consultation");
    // formData.append('terms_condition', data.terms_condition); // Corrected field key

    // Optional file upload if needed
    if (data.file) {
        formData.append('file', data.file); // This must be a File or Blob
    }

    try {
        const response = await fetch(apiUrl, {
            method: 'POST',
            body: formData
        });

        const result = await response.json(); // Use .text() if response isn't JSON
        return result;
    } catch (error) {
        console.error('Error sending email:', error);
        return { success: false, error };
    }
};

export const sendEmailworkflow = async (data) => {
    const apiUrl = 'https://sitecontact.hasotech.com/sendmailworkflow.php';

    const formData = new FormData();
    formData.append('name', data.name);
    formData.append('company', data.company);
    formData.append('email', data.email);
    formData.append('phone', data.phone);
    formData.append('revenue', data.revenue);
    formData.append('industry', data.industry);
    formData.append('country', data.country);
    formData.append('comment', data.comment);
    formData.append('page_name', 'form submitted from the workflow page');

    // Optional file upload if needed
    if (data.file) {
        formData.append('file', data.file); // This must be a File or Blob
    }

    try {
        const response = await fetch(apiUrl, {
            method: 'POST',
            body: formData
        });

        const result = await response.json(); // Use .text() if response isn't JSON
        return result;
    } catch (error) {
        console.error('Error sending email:', error);
        return { success: false, error };
    }
};

export const sendEmailsellersspecspage = async (data) => {
    const apiUrl = 'https://sitecontact.hasotech.com/sendmailworkflow.php';

    const formData = new FormData();
    formData.append('name', data.name);
    formData.append('company', data.company);
    formData.append('email', data.email);
    formData.append('phone', data.phone);
    formData.append('revenue', data.revenue);
    formData.append('industry', data.industry);
    formData.append('country', data.country);
    formData.append('comment', data.comment);
    formData.append('page_name', 'form submitted from the sellersspecs page');

    // Optional file upload if needed
    if (data.file) {
        formData.append('file', data.file); // This must be a File or Blob
    }

    try {
        const response = await fetch(apiUrl, {
            method: 'POST',
            body: formData
        });

        const result = await response.json(); // Use .text() if response isn't JSON
        return result;
    } catch (error) {
        console.error('Error sending email:', error);
        return { success: false, error };
    }
};

export const sendEmailSmbLanding = async (data) => {
    const apiUrl = 'https://sitecontact.hasotech.com/sendmailworkflow.php';

    const formData = new FormData();
    // formData.append('name', data.name);
    // formData.append('company', data.company);
    formData.append('email', data.email);
    // formData.append('phone', data.phone);
    // formData.append('revenue', data.revenue);
    formData.append('industry', data.industry);
    // formData.append('country', data.country);
    // formData.append('comment', data.comment);
    formData.append('page_name', 'form submitted from the smblanding page');

    // Optional file upload if needed
    if (data.file) {
        formData.append('file', data.file); // This must be a File or Blob
    }

    try {
        const response = await fetch(apiUrl, {
            method: 'POST',
            body: formData
        });

        const result = await response.json(); // Use .text() if response isn't JSON
        return result;
    } catch (error) {
        console.error('Error sending email:', error);
        return { success: false, error };
    }
};


export const sendEmailcustomappdev = async (data) => {
    const apiUrl = 'https://sitecontact.hasotech.com/sendmailworkflow.php';

    const formData = new FormData();
    
    formData.append('name', data.name);
    formData.append('company', data.company);
    formData.append('email', data.email);
    formData.append('phone', data.phone);
    formData.append('revenue', data.revenue);
    formData.append('industry', data.industry);
    formData.append('country', data.country);
    formData.append('comment', data.comment);
    formData.append('page_name', 'form submitted from the Custom app development page');
    // Optional file upload if needed
    if (data.file) {
        formData.append('file', data.file); // This must be a File or Blob
    }

    try {
        const response = await fetch(apiUrl, {
            method: 'POST',
            body: formData
        });

        const result = await response.json(); // Use .text() if response isn't JSON
        return result;
    } catch (error) {
        console.error('Error sending email:', error);
        return { success: false, error };
    }
};
// export const sendGuideEmail = async (data) => {
//     // Create the email template
//     // Get first name from full name
//     const firstName = data.name.split(' ')[0];

//     // Format HTML content for the email with the new template style
//     const htmlContent = `
//     <html>
//     <head>
//         <style>
//             body {
//             font-family: Arial, sans-serif;
//             line-height: 1.5;
//             color: #333;
//             max-width: 600px;
//             margin: 0 auto;
//             padding: 20px;
//         }

//         .container {
//             background-color: #031f3a;
//             border-radius: 15px;
//             border: 1px solid #eee;
//             border-radius: 5px;
//             padding: 40px;
//             margin-top: 20px;
//         }

//         .content-body {
//             background-color: white;
//             padding: 15px;
//             border-radius: 15px;
//         }

//         .logo {
//             text-align: center;
//             margin-bottom: 30px;
//         }

//         .logo img {
//             width: 50px;
//             height: 50px;
//         }

//         h1 {
//             font-size: 24px;
//             font-weight: bold;
//             margin-bottom: 25px;
//             color: #222;
//             text-align: center;
//         }

//         p {
//             margin-bottom: 16px;
//         }

//         .button {
//             display: inline-block;
//             background-color: #031f3a;
//             color: white !important;
//             text-decoration: none;
//             padding: 10px 20px;
//             border-radius: 20px;
//             font-weight: bold;
//             margin: 20px 0;
//             text-align: center;
//         }

//         .footer {
//             display: flex;
//             justify-content: space-between !important;
//             margin-top: 30px;
//             border-top: 1px solid #eee;
//             padding-top: 20px;
//             font-size: 14px;
//             color: #666;
//         } 
//         </style>
//     </head>
//     <body>
//         <div class="container">
//         <div class="content-body">
//             <div class="logo">
//                 <img src="https://hasotech.com/assets/img/hfavicon.png" alt="HasoTechnology Logo">
//             </div> 

//             <p>Hi ${firstName},</p>

//             <p>Thanks for requesting "The Business Owner's Guide to Choosing the Right Software". This link is valid for 48 hours.</p>

//             <div style="text-align: center;">
//                 <a href="https://drive.usercontent.google.com/download?id=1VNFNelPVi3q_nKrRxZM9QUT3dKVnkYBP&export=download&authuser=1&confirm=t&uuid=746be415-9e9c-428b-bd9f-0a2f95245d6a&at=APcmpozD_KrNRD2AkXNnbPKw7n7Y:1745841437452" download="HasoTechnology_Profile.pdf" class="button">Download Guide</a>
//             </div>

//             <p>Whether you're a startup founder or scaling an established business, this guide will help you:</p>

//             <ul>
//                 <li>Identify what your business really needs</li>
//                 <li>Compare off-the-shelf vs. custom solutions</li>
//                 <li>Avoid costly mistakes</li>
//                 <li>Choose software that grows with you</li>
//             </ul>

//             <p>Want more?<br>
//             ${data.consent ? "Since you opted in for updates, you're all set to receive actionable insights, tech trends, and smart business tips straight to your inbox - no fluff, just value." : "If you want to receive updates with actionable insights, tech trends, and smart business tips straight to your inbox, you can subscribe anytime at www.hasotech.com."}</p>

//             <p>P.S. Got questions about your software needs? Just hit reply, or <a href="https://calendly.com/dilipwk/the-next-step">schedule a Free Consultation Call Now</a>.</p>
//             </div>
//              <div class="footer">
//                 <p>To your growth,</p>

//                 <p>Dilip Kumar K K<br>
//                 Founder, HasoTechnology<br>
//                 📩 sales@hasotech.com<br>
//                 🌐 www.hasotech.com</p> 
//             </div>
//         </div>
//     </body>
//     </html>
//     `;

//     // Brevo API configuration
//     const apiUrl = 'https://sitecontact.hasotech.com/sendmailpopup.php';
//     const apiKey = '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';

//     try {
//         const response = await fetch(apiUrl, {
//             method: 'POST',
//             headers: {
//                 'accept': 'application/json',
//                 'api-key': apiKey,
//                 'content-type': 'application/json'
//             },
//             body: JSON.stringify({
//                 sender: {
//                     name: "HasoTechnology",
//                     email: "hasoteck@gmail.com"
//                 },
//                 to: [
//                     {
//                         email: data.email,
//                         name: data.name
//                     }
//                 ],
//                 subject: "Your Free Guide: Choosing the Right Software for Your Business",
//                 htmlContent: htmlContent
//             })
//         });

//         const result = await response.json();
//         return { status: "success", data: result };
//     } catch (error) {
//         console.error("Error sending email:", error);
//         return { status: "error", message: error.message };
//     }
// };

export const sendGuideEmail = async (data) => {
    const apiUrl = 'https://sitecontact.hasotech.com/sendmailpopup.php';

    // Create FormData and append the required fields
    const formData = new FormData();
    formData.append('name', data.name);
    formData.append('email', data.email);

    try {
        const response = await fetch(apiUrl, {
            method: 'POST',
            body: formData
        });

        const result = await response.json();
        return result;

    } catch (error) {
        console.error('Error sending guide email:', error);
        return { success: false, error };
    }
};


export const sendEmailHr = async (data) => {
    const apiUrl = 'https://sitecontact.hasotech.com/resumesend.php';

    const formData = new FormData();
    formData.append('name', data.name);
    formData.append('email', data.email);
    formData.append('phone', data.phone);
    formData.append('comment', data.comment);
    formData.append('terms_condition', data.terms_condition);
    if (data.resume) {
        formData.append('resume', data.resume); // data.resume must be a File object
    }

    try {
        const response = await fetch(apiUrl, {
            method: 'POST',
            body: formData
        });
        const result = await response.json();
        return result;
    } catch (error) {
        console.error('Error sending HR email:', error);
        return { success: false, error };
    }
};

export const resetForm = (actions, recaptcha) => {
    if (actions) {
        actions.resetForm()
        actions.setStatus(true)
        actions.setSubmitting(false);
        setTimeout(() => actions.setStatus(false), 5000)
    }

    if (recaptcha) {
        recaptcha.current.reset();
        recaptcha.current.captcha.classList.remove("error");
    }
}

// Header Menu Position
export const SetHeaderMenuPos = () => {

    function setMegaMenuPos() {
        let menu = document.querySelectorAll(".megamenu");
        if (menu.length > 0) {

            menu.forEach(item => {
                let menuWidth = item.clientWidth,
                    menuLeftPos = item.getBoundingClientRect().left;

                if (menuLeftPos + menuWidth >= window.screen.width) {
                    item.style.left = `-${(menuLeftPos + menuWidth) - window.innerWidth + 25}px`;
                }
            })
        }
    }

    function setSimpleMenuPos() {
        let menu = document.querySelectorAll(".simple-dropdown-menu");

        if (typeof (menu) != 'undefined' && menu != null) {
            menu.forEach(item => {
                let pos = item.getBoundingClientRect().left,
                    posTop = item.getBoundingClientRect().top,
                    width = item.clientWidth,
                    height = item.clientHeight;

                if (pos + width + 10 > window.innerWidth) {
                    item.style.left = `${window.innerWidth - (pos + width + 10)}px`;
                    item.classList.add("menu-left");
                }

                if ((posTop + height) > window.innerHeight) {
                    item.style.transform = `translateY(${-(posTop + height - window.innerHeight)}px)`;
                }
            })
        }
    }

    setMegaMenuPos();
    setSimpleMenuPos();

    window.addEventListener('resize', (event) => {
        setTimeout(() => {
            setMegaMenuPos();
            setSimpleMenuPos();
        }, 500);
    });
}

export const setDocumentFullHeight = () => {
    const documentHeight = () => {
        const doc = document.documentElement
        doc.style.setProperty('--viewport-height', `${window.innerHeight}px`)
    }

    window.addEventListener("resize", documentHeight)
    documentHeight()
}